import React from "react";
import "./partners-page.scss"

import uC from "./img/brand_ucat.png"

import { useTranslation } from "react-i18next";

const ArrayImg = [uC]

export function DataProvider(){
    const {t} = useTranslation()
    return(
        <div className="partner-info">
            <h1 className="partner-info_title">{t(`data-provider.title`)}</h1>
            {
                ArrayImg.map((el,index)=>{
                    return(
                        <div className="partner-info-case" key={index}>
                            <img className="partner-info-case_img" src={el} alt="" />
                            <div className="partner-info-case_inform">
                                <h1>{t(`data-provider.info.${index}.0`)}</h1>
                                <span>{t(`data-provider.info.${index}.1`)}</span>
                                <a href={t(`data-provider.info.${index}.2`)}>{t(`partners-points-of-sales.info.${index}.2`)}</a>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}